module.exports = __webpack_public_path__ + "img/wild_comming.f60942f1.png";